import { FC } from 'react';
import Typography from '@components/common/typography';
import { useUserContext } from '@hooks/context/useUserContext';
import { IModalComponentProps } from '@context/modal_context';
import firstImage from '@svg/illustrations/hello_kyc_first.svg';
import secondImage from '@svg/illustrations/hello_kyc_second.svg';
import thirdImage from '@svg/illustrations/hello_kyc_third.svg';
import styles from './styles.module.scss';
import Button from '@components/common/button';
import { useKycModals } from '@hooks/modals/useKycModals';
import { useLocales } from '@hooks/helpers/useLocales';

const HelloKycModal: FC<IModalComponentProps> = ({ onClose }) => {
    const { user } = useUserContext();
    const { handleOpenKycFirstModal } = useKycModals();
    const { submitLocale } = useLocales();

    return (
        <div className={styles.wrapper}>
            <Typography variant="h4" className={styles.title} alignment="center" weight="bold">
                Hi {user?.profile?.first_name}, thanks for joining XEPPT!
            </Typography>
            <Typography variant="body3" className={styles.description} alignment="center">
                We just need a few more things before you can start using XEPPT products and
                services
            </Typography>
            <div className={styles.content}>
                <div className={styles.step}>
                    <img src={firstImage} alt="" />
                    <div className={styles.text_wrapper}>
                        <Typography variant="body2" weight="semibold">
                            1. Verify your identity
                        </Typography>
                        <Typography variant="body3">
                            We need to verify one of your identity documents and a selfie. This
                            process should only take a few minutes to complete
                        </Typography>
                    </div>
                </div>
                <div className={styles.step}>
                    <img src={secondImage} alt="" />
                    <div className={styles.text_wrapper}>
                        <Typography variant="body2" weight="semibold">
                            2. Get approved
                        </Typography>
                        <Typography variant="body3">
                            We will review your identity document and selfie and send you an email
                            with the status of your verification
                        </Typography>
                    </div>
                </div>
                <div className={styles.step}>
                    <img src={thirdImage} alt="" />
                    <div className={styles.text_wrapper}>
                        <Typography variant="body2" weight="semibold">
                            3. Start using XEPPT
                        </Typography>
                        <Typography variant="body3">
                            Once your identity is approved, you can start using your wallet’s
                            features and order your XEPPT card
                        </Typography>
                    </div>
                </div>
            </div>
            <div className={styles.actions}>
                <Button size="medium" variant="outlined-primary" onClick={onClose}>
                    {submitLocale('do_this_later')}
                </Button>
                <Button size="medium" variant="primary" onClick={handleOpenKycFirstModal}>
                    {submitLocale('start')}
                </Button>
            </div>
        </div>
    );
};

export default HelloKycModal;
